import { render, staticRenderFns } from "./BackToTheFutureR2.vue?vue&type=template&id=0efe7eee&scoped=true"
import script from "./BackToTheFutureR2.vue?vue&type=script&lang=ts"
export * from "./BackToTheFutureR2.vue?vue&type=script&lang=ts"
import style0 from "./BackToTheFutureR2.vue?vue&type=style&index=0&id=0efe7eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efe7eee",
  null
  
)

export default component.exports